export const iconStyle = {
    color: '#e85a2c',
    '&:hover': {
        backgroundColor: '#ebf8fa',
    },
};